<template>
  <div class="bulk-users-modal" style="position: relative;">
    <!-- Loading overlay -->
    <div v-if="loading" class="loading-overlay" data-cy="loading-overlay">
      <b-spinner variant="primary" />
      <p>Procesando usuarios masivos, por favor espere...</p>
    </div>

    <h3 class="import-title" data-cy="modal-title">Creación masiva de usuarios</h3>
    <p class="modal-desc" data-cy="modal-description">
      Adjunta un archivo <strong>CSV</strong> o <strong>Excel</strong> con los siguientes campos,
      en el orden exacto y separados por ";".
    </p>
    <ol class="fields-list" data-cy="fields-list">
      <li><span class="field-label">Rut:</span> Usuario sin puntos, con guion. Ej: xxxxxxxx-x</li>
      <li><span class="field-label">Nombre:</span> Nombre usuario</li>
      <li><span class="field-label">Apellidos:</span> Apellidos usuario</li>
      <li><span class="field-label">Alias:</span> Alias usuario</li>
      <li><span class="field-label">Correo:</span> Correo de contacto</li>
    </ol>

    <div v-if="errorArchivo" class="error-txt" data-cy="file-error">{{ errorArchivo }}</div>

    <div class="btn-row" v-if="!archivo">
      <vs-button
        class="text.primary import-btn"
        @click="descargarEjemplo('csv')"
        icon="file_download"
        :loading="cargandoCsv"
        data-cy="download-csv-example"
      >
        {{ cargandoCsv ? 'Descargando...' : 'Descargar CSV ejemplo' }}
      </vs-button>
      <vs-button
        class="text.primary import-btn"
        @click="descargarEjemplo('excel')"
        icon="file_download"
        :loading="cargandoExcel"
        data-cy="download-excel-example"
      >
        {{ cargandoExcel ? 'Descargando...' : 'Descargar Excel ejemplo' }}
      </vs-button>
    </div>

    <div class="btn-row">
      <vs-button
        v-if="!archivo"
        class="import-btn upload"
        color="primary"
        @click="openFileDialog"
        icon="file_upload"
        data-cy="btn-select-file"
      >
        Selecciona un archivo
      </vs-button>
      <div v-else
           class="file-row"
           style="display: flex;
           align-items: center;
           gap: 10px;
           justify-content: center;"
      >
        <vs-chip class="file-chip" color="primary" data-cy="file-name">{{ archivo.name }}</vs-chip>
        <vs-button
          type="flat"
          style="min-width:32px;font-size:1.1rem;padding:6px 8px;"
          color="primary"
          icon="file_upload"
          @click="openFileDialog"
          data-cy="btn-change-file"
        >
          Cambiar archivo
        </vs-button>
      </div>
      <input
        ref="archivo"
        type="file"
        accept=".csv,.xlsx"
        style="display:none"
        @change="handleFileUpload"
        data-cy="input-file"
      />
    </div>

    <div v-if="archivo" class="btn-row">
      <vs-button class="finish-btn"
                 color="success"
                 @click="procesarMasivo"
                 :loading="loading"
                 data-cy="btn-create-users"
      >
        Crear Usuarios
      </vs-button>
    </div>

    <div v-if="uploadProgress > 0 && uploadProgress < 100"
         class="prog-row"
         data-cy="progress-bar-container"
    >
      <progress max="100" :value="uploadProgress" data-cy="progress-bar"></progress>
      <span data-cy="progress-percentage">{{ uploadProgress }}%</span>
    </div>
    <div v-if="mensaje"
         class="alert alert-info msg-row"
         data-cy="success-message">
      {{ mensaje }}
    </div>
    <div v-if="errorCreacion"
         class="alert alert-danger msg-row"
         data-cy="error-message">{{ errorCreacion }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { ioDownloadPrivateFile, ioGetPrivateUploadUrl, ioUploadFileToPrivateUrl } from '@/febos/servicios/api/herramientas.api';
import { ioCreateMassiveUsers } from '@/febos/servicios/api/v2.companies.api';

export default {
  data() {
    return {
      archivo: null,
      loading: false,
      cargandoCsv: false,
      cargandoExcel: false,
      uploadProgress: 0,
      privateUrl: '',
      mensaje: '',
      errorArchivo: '',
      errorCreacion: ''
    };
  },
  computed: {
    ...mapGetters('Empresas', [
      'company'
    ])
  },
  methods: {
    async descargarEjemplo(tipo) {
      if (tipo === 'csv') {
        this.cargandoCsv = true;
        try {
          const response = await ioDownloadPrivateFile({
            path: `/febos-io/chile/${process.env.VUE_APP_AMBIENTE}/usuario-masivo/ejemplo_ed_usuarios_masivos.csv`,
            nombre: 'ejemplo_usuarios_masivos.csv'
          });
          if (response.data.codigo === 10) {
            window.open(response.data.url, '_blank');
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Descarga de ejemplo CSV',
              text: `${response.data.mensaje }<br/><b>Seguimiento: </b>${ response.data.seguimientoId}`,
              time: 10000
            });
          }
        } catch (e) {
          this.$vs.notify({
            color: 'danger',
            title: 'Descarga de ejemplo CSV',
            text: 'No fue posible descargar el archivo de ejemplo',
            time: 10000
          });
        } finally {
          this.cargandoCsv = false;
        }
      } else if (tipo === 'excel') {
        this.cargandoExcel = true;
        try {
          const response = await ioDownloadPrivateFile({
            path: `/febos-io/chile/${process.env.VUE_APP_AMBIENTE}/usuario-masivo/ejemplo_ed_usuarios_masivos.xlsx`,
            nombre: 'ejemplo_usuarios_masivos.xlsx'
          });
          if (response.data.codigo === 10) {
            window.open(response.data.url, '_blank');
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Descarga de ejemplo Excel',
              text: `${response.data.mensaje }<br/><b>Seguimiento: </b>${ response.data.seguimientoId}`,
              time: 10000
            });
          }
        } catch (e) {
          this.$vs.notify({
            color: 'danger',
            title: 'Descarga de ejemplo Excel',
            text: 'No fue posible descargar el archivo de ejemplo',
            time: 10000
          });
        } finally {
          this.cargandoExcel = false;
        }
      }
    },
    openFileDialog() {
      this.$refs.archivo.click();
    },
    handleFileUpload(e) {
      const archivo = e.target.files[0];
      this.archivo = archivo;
      this.errorArchivo = '';
      this.errorCreacion = '';
      this.privateUrl = '';
      this.uploadProgress = 0;
    },
    async procesarMasivo() {
      if (!this.archivo) {
        this.errorArchivo = 'Debes seleccionar un archivo';
        return;
      }
      this.loading = true;
      this.mensaje = '';
      this.errorCreacion = '';
      this.uploadProgress = 0;
      this.privateUrl = '';

      const url = `/febos-io/chile/${process.env.VUE_APP_AMBIENTE}/archivos/empresa/${this.company.iut}/masivos/${this.archivo.name}`;
      try {
        const urlResponse = await ioGetPrivateUploadUrl(url, this.archivo);
        await ioUploadFileToPrivateUrl(
          urlResponse.data?.url,
          this.archivo,
          (percent) => { this.uploadProgress = percent; }
        );
        const payload = {
          empresaId: this.company.id,
          file: url
        };
        const responseCreate = await ioCreateMassiveUsers(payload);
        if (responseCreate.data.codigo === 10) {
          this.mensaje = 'Usuarios creados correctamente.';
          this.archivo = null;
          this.$emit('close-manage-massive-users');
        } else {
          this.errorCreacion = responseCreate.data.mensaje || 'Error en la operación';
          this.$vs.notify({
            color: 'danger',
            title: 'Error',
            text: this.errorCreacion,
            time: 4000
          });
        }
      } catch (err) {
        this.errorCreacion = err.response?.data?.mensaje || 'Error al crear usuarios.';
      } finally {
        this.loading = false;
        this.uploadProgress = 0;
      }
    }
  }
};
</script>

<style scoped>
.bulk-users-modal {
  max-width: 600px;
  margin: 0 auto;
  background: #fff;
  border-radius: 13px;
  box-shadow: 0 6px 32px #eaeaea78;
  padding: 32px 32px 20px 32px;
  font-family: 'Inter', Arial, sans-serif;
  text-align: center;
}

.import-title {
  color: #ef5a1a;
  font-size: 1.38rem;
  font-weight: 700;
  margin-bottom: 8px;
  text-align: center;
  line-height: 1.2;
}

.modal-desc {
  color: #474d5d;
  font-size: 1rem;
  margin-bottom: 15px;
}
.fields-list {
  background: #f8f8fa;
  border-radius: 8px;
  padding: 16px 14px 16px 22px;
  font-size: 1rem;
  text-align: left;
  margin-bottom: 19px;
  color: #404568;
  margin-top: 0;
}
.fields-list .field-label {
  font-weight: 600;
  color: #6245b7;
}

.btn-row {
  display: flex;
  gap: 13px;
  justify-content: center;
  margin-bottom: 16px;
}

.import-btn {
  min-width: 220px;
  padding: 9px 0 !important;
  font-size: 0.98rem !important;
  border-radius: 7px !important;
  font-weight: 500;
  color: #fff!important;
  box-shadow: 0 2px 10px #edeafd33;
}
.import-btn.upload {
  background: #2378f6 !important;
  color: #fff !important;
}
.finish-btn {
  min-width: 220px;
  padding: 11px 0 !important;
  font-size: 1.06rem !important;
  border-radius: 7px !important;
  background: #48c37e !important;
  color: #fff !important;
  font-weight: 600;
  margin-top: 2px;
}
.file-row {
  margin: 5px 0 8px 0;
}
.file-chip {
  color: #fff !important;
  border-radius: 14px !important;
  font-size: 0.97rem !important;
  padding: 6px 20px !important;
}

.error-txt {
  color: #e73345;
  font-size: 0.97rem;
  margin-bottom: 12px;
}
.prog-row {
  margin: 10px 0 4px 0;
  text-align: center;
  color: #7933bb;
  font-weight: 500;
}
.msg-row {
  margin: 7px 0 0 0;
  font-size: 1rem;
  border-radius: 8px;
  text-align: center;
}

.loading-overlay {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.85);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  font-weight: 600;
  font-size: 1.1rem;
  color: #3e3e3e;
}
</style>
